import { CheckCircle2, LandmarkIcon } from "lucide-react";
import { useBankAccountsQuery } from "src/apps/PostFundedDashboard/queries";
import { useActiveApplicantApplicationQuery } from "src/hooks/useApplication";

import { usePlaid } from "src/apps/PreFundedDashboard/hooks/plaid";
import { AssetList } from "src/components/AssetList";
import { BankAccountList } from "src/components/BankAccountList";
import { DebtList } from "src/components/DebtList";
import { Button } from "src/components/ui/button";
import PlaidLogo from "src/icons/plaid-logo.svg?react";

const IncomeVerify = () => {
  const { app } = useActiveApplicantApplicationQuery({ initialRefetch: false });

  const {
    start,
    ready,
    isLoading,
    registerMutation,
    bankStatements,
    isLoadingBankStatements,
    assets,
    debts,
    incomes,
    isLoadingApp,
  } = usePlaid({
    applicationId: app?.id,
    purpose: "underwriting",
  });
  const { data: bankAccounts, isLoading: isLoadingBankAccounts } = useBankAccountsQuery();

  return (
    <div className="flex flex-col p-6 gap-y-4">
      <div className="flex flex-row justify-between items-center gap-x-14">
        <div>
          <p className="font-semibold text-3xl mb-1">Connect a bank account</p>
          <p>
            Connect your bank account to automatically pull statements and verify your income using{" "}
            <a
              className="text-green font-semibold inline-block"
              href="https://plaid.com"
              target="_blank"
              rel="noreferrer"
            >
              <PlaidLogo width={16} height={16} className="inline-block mb-1" /> Plaid.
            </a>
          </p>
        </div>

        <div>
          <Button
            className="self-start"
            pendingWithIcon={isLoading}
            onClick={() => start()}
            disabled={isLoading || !ready}
          >
            {registerMutation?.data ? (
              <CheckCircle2 height={16} width={16} className="text-white mr-2" />
            ) : null}
            {registerMutation?.data ? "Bank connected!" : "Connect a bank account"}
            <LandmarkIcon height={16} width={16} className="ml-2" />
          </Button>
        </div>
      </div>

      <div>
        <BankAccountList
          applicationId={app?.id}
          incomesLoading={isLoadingApp}
          bankAccountsLoading={isLoadingBankAccounts}
          bankStatementsLoading={isLoadingBankStatements}
          pendingConnect={isLoading}
          onClickConnect={() => start()}
          bankAccounts={bankAccounts}
          incomes={incomes}
          bankStatements={bankStatements}
        />
      </div>
      <div>
        {debts?.length ? <p className="font-semibold text-2xl mb-2">Your debts</p> : null}
        <DebtList debts={debts} />
      </div>
      <div>
        {debts?.length ? <p className="font-semibold text-2xl mb-2">Your other assets</p> : null}
        <AssetList assets={assets} />
      </div>
    </div>
  );
};

export default IncomeVerify;
